import { useMutation } from '@tanstack/react-query';
import { TempApi } from 'api';
import type { TempPayment } from 'api/methods/TempApi';

/**
 * [Temp] 주문 생성
 * --
 */
export const useCreateTempPayment = () => {
  const { mutateAsync: createTempPayment, ...result } = useMutation({
    mutationFn: (variables: TempPayment) =>
      TempApi.createTempPayment(variables),
  });

  return { createTempPayment, ...result };
};

/**
 * [Temp] 선물 생성
 * --
 */
export const useCreateTempPresent = () => {
  const { mutateAsync: createTempPresent, ...result } = useMutation({
    mutationFn: (variables: TempPayment) =>
      TempApi.createTempPresent(variables),
  });

  return { createTempPresent, ...result };
};
